var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialogModel',{attrs:{"title":"编辑企业详情","visible":_vm.EnterpriseDetails},on:{"update:visible":function($event){_vm.EnterpriseDetails=$event},"handleClose":_vm.handleCloseEnterpriseDetails,"handleOk":_vm.handelEnterpriseDetails}},[_c('div',{staticClass:"main-body"},[_c('div',{staticClass:"MajorItems"},[_vm._v(" 编辑企业详情 富文本编辑器位置 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }